module.exports = __webpack_public_path__ + "img/design.25388ef.jpg";